export enum PATHS {
  IMPORT_WIZARD = '/importer/v2/',
}
